/**
  * @class meleActorAlpr
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-alpr>` custom web element for showing recognised license plate in <mele-channel>
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
}, meleActor._properties)

export default class meleActorAlpr extends meleActor {
  init() {
    super.init()
    this.listener = this.closest('.mele-player').listener
  }

  message({ action, params }) {
    if(action !== 'mmAlpr') return
    const { oid, lpn, severity } = params
    const key = Date.now()
    const el = this.prependChildren({
      tag: 'alpr',
      key,
      class: severity>=3 ? 'alert' : severity>=2 ? 'special' : severity>=1 ? 'warning' : 'ok',
      html: `
        ${lpn}
      `,
    })
    el.onclick = ()=>{
      this.listener.publish('msysWM', 'mmWindowFocus', { id: 'mmodAlpr' })
      this.listener.publish('mmodAlpr', 'mmOpen', { id: oid })
    }
    setTimeout(()=>{
      el.deleteElement()
    }, 30000)
  } // message
} // class meleActorAlpr

meleActorAlpr._properties = PROPERTIES
meleActorAlpr.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-alpr', meleActorAlpr)
